<script>
  import axios from 'axios';

  export default {
    props: {
      item: Object,
      index: Number,
    },
    data: () => ({ }),
    methods: {
      goToItem() {
      }
    },
  };
</script>

<template>
  <v-list-item :key="index">
    <v-list-item-content class="search-item" v-if="item.Type === 1">
      <span style="float: left;">{{ item.AgreementData.DateBegin.Serialized }}
      <b>{{item.AgreementData.Code}}<span v-if="item.AgreementData.OperatorCode && item.AgreementData.OperatorCode.length">/</span>{{item.AgreementData.OperatorCode}}</b>
      {{item.AgreementData.Operator}}, {{item.AgreementData.Country}} - {{item.AgreementData.City}} {{item.AgreementData.Status}}
      </span>
      {{item.AgreementData.OperatorPrice|price}}/{{item.AgreementData.ClientPrice|price}} {{item.AgreementData.CurrencyCode}}
      <br/>
      {{item.AgreementData.ClientName}}
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 1">
      <v-btn :href="'/tourclient/admin/orders/info.html?code=' + item.AgreementData.Code" title="Перейти к путевке" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 2">
      Лид от {{ item.DateCreate.Serialized }}: {{ item.LeadData.Name }} {{item.LeadData.Country}} {{item.LeadData.Status}}
      <br/>
      {{item.LeadData.ClientName}}
      <br/>
      {{item.LeadData.DepartmentName}} {{item.LeadData.ManagerName}}
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 2">
      <v-btn :href="'/tourclient/admin/leads/edit_full.html?id=' + item.Id" title="Перейти к лиду" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 3">
      Турист: {{ item.ClientData.ClientName }} {{ item.ClientData.Phone }} {{item.ClientData.Email}}
      <br/>
      {{ item.ClientData.PassportRusSeries }} {{ item.ClientData.PassportRusNumber }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.ClientData.PassportSeries }} {{item.ClientData.PassportNumber}}
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 3">
      <v-btn :href="'/tourclient/admin/clients/edit_full.html?id=' + item.Id" title="Перейти к туристу" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 4">
      Платеж: {{ item.PaymentData.DocumentNumber }}
      <span v-if="item.PaymentData.InOut === 1">приход</span>
      <span v-else>расход</span>
      {{item.PaymentData.Sum|price}} {{item.PaymentData.CurrencyCode}}
      <br/>
      <span v-if="item.PaymentData.AgreementCode && item.PaymentData.AgreementCode.length">
        Путевка: {{item.PaymentData.AgreementCode}}
      </span>
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 4">
      <v-btn :href="'/tourclient/index.html#/finances/payments/edit/' + item.Id" title="Перейти к платежу" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 5">
      {{ item.PartnerData.Name }} {{ item.PartnerData.LegalEntityName }}
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 5">
      <v-btn :href="'/tourclient/dictionary/#/partner/edit/' + item.Id" title="Перейти к партнеру" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 6">
      Сертификат на {{ item.GiftCertificate.Sum|price }} {{ item.GiftCertificate.CurrencyCode }}
      <span v-if="item.GiftCertificate.ClientName && item.GiftCertificate.ClientName.length">Турист: {{item.GiftCertificate.ClientName}}</span>
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 6">
      <v-btn :href="'/tourclient/index.html#/finances/certificates/edit/' + item.Id" title="Перейти к сертификату" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content class="search-item" v-if="item.Type === 7">
      Задача: {{ item.TaskData.Name }} {{ item.TaskData.StartDate.Serialized }} - {{item.TaskData.EndDate.Serialized}}
      <br/>
      Назначена: {{ item.TaskData.AssigneeName }}
      <br/>
      Создатель: {{ item.TaskData.CreatorName }}
    </v-list-item-content>
    <v-list-item-action v-if="item.Type === 7">
      <v-btn :href="'/tourclient/admin/tasks/edit.html?id=' + item.Id" title="Перейти к задаче" color="blue-grey" icon>
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<style lang="scss">
  .search-item {
    font-size: 12px;
  }
</style>